const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    minHeight: 0,
    minWidth: 0,
    padding: '30px 48px 0',

    [theme.breakpoints.down('sm')]: {
      padding: '0px 32px',
    },
  },
});

class Page extends React.Component {
  render() {
    const { classes, className, children } = this.props;

    return (
      <div className={classnames(classes.root, className)}>{children}</div>
    );
  }
}

Page.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node,
};

export default withStyles(styles)(Page);
